import React, { Fragment, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import localization from "assets/localization/localization";
import Layout from "components/sales/layout/layout";
import { Button, Image } from "react-bootstrap";
import Images from "assets/images/imageData";
import GSTDetails from "components/sales/formSection/GSTDetails/gstDetails";
import GateDetails from "components/sales/formSection/gateDetails/gateDetailsApt";
import OtherDetails from "components/sales/formSection/otherDetails/otherDetails";
import Commercial from "components/sales/formSection/commercial/commercial";
import ParkingRules from "components/sales/formSection/parkingRules/parkingRules";
import BilledTo from "components/sales/formSection/billedTo/billedTo";
import ShippedTo from "components/sales/formSection/shippedTo/shippedTo";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { Link } from "react-router-dom";
import AgreementContract from "components/sales/formSection/agreementContract/agreementContract";
import MaterialHardware from "components/sales/formSection/materialHardware/materialHardware";
import ClientDetails from "components/sales/formSection/clientDetails/clientDetails";
import Tags from 'components/sales/formSection/materialHardware/tags';
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStone';
import AdvancePayment from 'components/sales/formSection/materialHardware/advancePayment';
import Increament from 'components/sales/formSection/materialHardware/increament';
import { ToastContainer, toast } from "react-toastify";
import ErrModalPop from 'components/sales/modal/errorModal';
import parse from 'html-react-parser';
import InvoiceModule from "../../../../components/sales/formSection/materialHardware/invoiceModule";
import AddPoc from "../../../../components/sales/formSection/addPoc/addPoc";
import {getContractRevenue} from "../../../../services/redux/sales/postSales/action";
import B2BRevenue from "../B2BRevenue";
import ContractServices from "../ContractServices";

const PostSalesSupply = (props) => {
  const {
    history,
    postSupply,
    postSupplyData,
    pincodeData,
    locationPinCode,
    postSalesSupplyLead,
    documentUploadUrl,
    documentUrlData,
    match,
    getMaterial,
    getMateriaById,
    getBrandById,
    getBrand,
    imageUploadUrl,
    videoUploadUrl,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress,
    getContractRevenue,
    contractRevenueDetails=[],
    getContractService,
    contractCatService=[]
  } = props; //console.log('OOOK ' + JSON.stringify(postSupplyData?.lead_type_val));
  const { params } = match;
  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    parkingRules: null,
    shippedTo: null,
    billedTo: null,
    otherDetails: null,
    gateDetails: null,
    category: [],
    gates: null,
    agreementDtls: null,
    materialHardwares: "No",
    InvoiceModuleData:null,
    pocData: null,
    revenue_nature: 'Self',
    revenue_type:'Fixed',
    invoice_type: 'Post'
  };

  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [variableServices, setVariableServices] = useState([{id:'', amount:'', qty:'', men_days:0, start_day:'', end_day:''}])
  const [fixedServices, setFixedServices] = useState([{id:'', amount:'', qty:'', men_days:0}])
  const [postSupplyInputs, setPostSupplyData] = useState(postDataInputs);
  const handleCommercial = (val) => {
    setPostSupplyData({ ...postSupplyInputs, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
    }
  };
  console.log("Post Supply Inputs:", postSupplyInputs)
  const handleGstDetails = (val) => {
    setPostSupplyData({ ...postSupplyInputs, gSTDetails: val });
  };
  const handleParkingRules = (val) => {
    setPostSupplyData({ ...postSupplyInputs, parkingRules: val });
  };
  const handleGateDtl = (val) => {
    setPostSupplyData({ ...postSupplyInputs, gateDetails: val });
    setIsGateDetailsChanged(true);
  };
  const handleMileStone = (val) => {
    setPostSupplyData({ ...postSupplyInputs, milestone: val });
  };
  const handleBillTo = (val) => {
    setPostSupplyData({ ...postSupplyInputs, billedTo: val });
  };
  const handleShippedTo = (val) => {
    setPostSupplyData({ ...postSupplyInputs, shippedTo: val });
  };
  const handleOtherDetails = (val) => {
    setPostSupplyData({ ...postSupplyInputs, otherDetails: val });
  };
  const handleGatesData = (val) => {
    setPostSupplyData({ ...postSupplyInputs, categoryInventory: val });
  };
  const handleProductData = (val) => {
    setPostSupplyData({ ...postSupplyInputs, productInventory: val });
  };
  const handleMaterialhardware = (val) => {
    setPostSupplyData({ ...postSupplyInputs, materialHardwares: val });
  };
  const handleagreementDtls = (val) => {
    setPostSupplyData({ ...postSupplyInputs, agreementDtls: val });
  };
  const handleTags = (val) => {
    setPostSupplyData({ ...postSupplyInputs, tagsData: val });
  };
  const handleClientData = (val) => {
    setPostSupplyData({ ...postSupplyInputs, clientData: val });
  };
  const handlePocData = (val) => {
    setPostSupplyData({ ...postSupplyInputs, pocData: val });
  };
  const handleInstallation = (val) => {
    setPostSupplyData({ ...postSupplyInputs, installation: val });
  };

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

  const handleSubmit = (id) => {
    const {
      commercial,
      gSTDetails,
      parkingRules,
      gateDetails,
      // billedTo,
      shippedTo,
      clientData,
      otherDetails,
      categoryInventory,
      productInventory,
      materialHardwares,
      agreementDtls,
      advPayment,
      installation,
      increamentData,
      tagsData,
      milestone,
      InvoiceModuleData,
      // pocData
      revenue_nature,
      revenue_type,
      invoice_type
    } = postSupplyInputs;
    if(postSupplyData.leadStatus !== 9 && (revenue_nature === null || revenue_nature === '')){
      toast.warning("Please contract revenue nature")
      return false
    }
    if (
      (postSupplyData.leadStatus <= 4 && (
        commercial != null &&
        gSTDetails != null &&
        // billedTo != null &&
        shippedTo != null &&
        agreementDtls != null &&
        clientData != null
        // && pocData !== null
      )) || (postSupplyData.leadStatus === 9 && postSupplyData?.commercialData?.revenue_nature !== 'Valet' && (gateDetails != null))
       ||
       (postSupplyData.leadStatus === 9 && (
        gateDetails != null &&
        MaterialHardware != null &&
        materialHardwares != null 
      ))
    ) {
      setIsFiled(false);
      if(clientData != null && clientData.billing_address !== undefined) {
        var fObj = {
          ...commercial,
          // ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          isNewContract:postSupplyData.isNewContract,
          gateDetails: gateDetails,
          leadStatus:postSupplyData.leadStatus,
          comm_id:postSupplyData.comm_id,
          materialHardwares: { ...materialHardwares },
          ...clientData.billing_address,
          // pocData: pocData
        }; 
      }else{
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          gateDetails: gateDetails,
          isNewContract:postSupplyData.isNewContract,
          leadStatus:postSupplyData.leadStatus,
          comm_id:postSupplyData.comm_id,
          materialHardwares: { ...materialHardwares },
          // pocData: pocData
          // ...clientData.billing_address
        }; 
      }

      // if (categoryInventory !== null && categoryInventory !== undefined) {
      //   fObj.categoryInventory = [
      //     ...categoryInventory,
      //     ...productInventory?.productData,
      //   ];
      // } else {
      //   fObj.categoryInventory = [];
      // }

      if (categoryInventory !== null && categoryInventory !== undefined && productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
        ];
      } else if (productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...productInventory?.productData,
        ];
      } else {
        fObj.categoryInventory = [];
      }


      if (tagsData !== null && tagsData !== undefined) {
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }
      if (advPayment !== null && advPayment !== undefined) {
        fObj.payment = [
          ...advPayment?.advData,
        ];
      } else {
        fObj.payment = [];
      }
      if (increamentData !== null && increamentData !== undefined) {
        if (increamentData?.inc?.increament_type) {
          if (increamentData?.inc?.increament_type == 'flat' || increamentData?.inc?.increament_type == 'percentage') {
            if (increamentData?.inc?.duration == undefined || increamentData?.inc?.increament_amount == undefined) {
              return false;
            }
          }
          fObj.increament = [
            increamentData
          ];
        } else {
          fObj.increament = [];
        }
      } else {
        fObj.increament = [];
      }
      if (milestone !== null && milestone != undefined) {
        let totalAmt = parseInt(postSupplyData?.commercialData?.total_mg_amount);
        let calculatedAmt = 0;
        if (!isNaN(totalAmt)) {
          if (totalAmt > 0) {
            for (let i = 0; i < postSupplyInputs.milestone?.milestone_data.length; i++) {
              if (postSupplyInputs.milestone.milestone_data[i].amt) {
                calculatedAmt += parseInt(postSupplyInputs.milestone.milestone_data[i].amt);
              }
            }
            for (let i = 0; i < postSupplyInputs.milestone?.date_invoices_data.length; i++) {
              if (postSupplyInputs.milestone.date_invoices_data[i].amt) {
                calculatedAmt += parseInt(postSupplyInputs.milestone.date_invoices_data[i].amt);
              }
            }
            for (let i = 0; i < postSupplyInputs.milestone?.retention.length; i++) {
              if (postSupplyInputs.milestone.retention[i].amt) {
                calculatedAmt += parseInt(postSupplyInputs.milestone.retention[i].amt);
              }
            }
            if (calculatedAmt > totalAmt) {
              toast.error('Milestone total amount is greater then capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            } else {
              fObj.milestone=milestone;
            }
          }
        }
      }

      fObj['revenue_nature'] = revenue_nature
      fObj['revenue_type'] = revenue_type
      fObj['invoice_type'] = invoice_type

      if(postSupplyData?.commercialData !== undefined && postSupplyData?.commercialData?.revenue_nature === 'Valet'){
        fObj['variable_services'] = variableServices
        fObj['fixed_services'] = fixedServices
       } else{
          fObj['invoice_type'] = 'Pre'
          fObj['revenue_type'] = 'Fixed'
      }

      if(InvoiceModuleData !== null && InvoiceModuleData != undefined){
        let subsAmt = Number(postSupplyData?.commercialData?.subscription_amount);
        let invoiceAmt = InvoiceModuleData?.invoiceAmt;
        const initialValue = 0;
        const sumWithInitial = invoiceAmt.reduce(
            (previousValue, currentValue) => previousValue + currentValue,
            initialValue
        );
        if(subsAmt === sumWithInitial ){
          fObj.InvoiceModuleData=InvoiceModuleData;
        }else{
          toast.error('Total amount of invoice module is not equal to the total subscription amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        }


      }
      if(parseInt(fObj['solution_type']) == 3 &&  (parseInt(fObj['commercialType']) !== 7 ||parseInt(fObj['paymentTerms']) !== 2)){
        toast.error('Please select commercial type as rental and payment terms as monthly for solution type services');
        return;
      }
      /* const fObj = {
        ...commercial,
        ...gSTDetails,
        ...parkingRules,
        ...billedTo,
        ...shippedTo,
        ...otherDetails,
        ...agreementDtls,
        gateDetails: gateDetails,
        materialHardwares: { ...materialHardwares },
      };
      if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else {
        fObj.categoryInventory = [];
      } */


      (async () => {
        const res = await postSalesSupplyLead({ ...fObj, leadId: id });
        if (res) {
          setIsModal(true);
        }
      })();
    }
    else {
      var errMsg = '';
      if(postSupplyData.leadStatus <= 4){

        if(commercial === null){
          errMsg = errMsg+'Commercial Detail Is Required!<br/>';
        }
        if(gSTDetails === null){
          errMsg = errMsg+'GST Detail Is Required! <br/>';
        }
        if(shippedTo === null){
          errMsg = errMsg+'Ship to Address Is Required! <br/>';
        }
        if(agreementDtls === null ||  Object.keys(agreementDtls).length == 0){
          errMsg = errMsg+'Agreement Details Is Required! <br/>';
        }
        if(clientData === null){
          errMsg = errMsg+'Client Detail Is Required! <br/>';
        }
        /*if (pocData === null) {
          errMsg = errMsg+'POC Details are Required! <br/>';
        }*/

      }else{
        if(gateDetails === null){
          errMsg = errMsg+'Commercial Detail Is Required!<br/>';
        }
        if(otherDetails === null){
          errMsg = errMsg+'GST Detail Is Required! <br/>';
        }
        if(MaterialHardware === null){
          errMsg = errMsg+'Please Select Material H/W Option! <br/>';
        }
        if(materialHardwares === null){
          errMsg = errMsg+'Material H/W Details Is Required! <br/>';
        }

      }
      setIsErrorMsg(errMsg);
      setIsErrorModal(true);
      setIsClicked(false);
      // console.log(agreementDtls)
      setIsFiled(true);
      const active = document.querySelector('.activeAnkInput');
      console.log(active);
      if(active){
        active.focus();
      }else{
        alert('Please Upload missed documents or enter valid data !')
      }
    }
  };

  useEffect(() => {

    (async () => {
      await postSupply(params.lead_id)
      await getContractRevenue()
      await getContractService('VALET')
    })();
  }, [postSupply]);

  const handleModalHide1 = () => setIsErrorModal(false);
  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(params.lead_id)}>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
        </Button>
      </Fragment>
    );
  };
  function refreshPage() {
    window.location.reload(false);
  }

  const handleInvoiceAmt = (val) => {
    setPostSupplyData({ ...postSupplyInputs, InvoiceModuleData: val });
  };

  const handleRevenueDetails = (key, value) => {
    postSupplyInputs[key] = value
    setPostSupplyData(postSupplyInputs);
  }

  const handleVariableService = (index, key, val) => {
    let list = [...variableServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      variableServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setVariableServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setVariableServices(list)
  }

  const handleFixedService = (index, key, val) => {
    let list = [...fixedServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      fixedServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setFixedServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setFixedServices(list)
  }

// console.log(postSupplyData);
  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      className={isFiled ? "requiredFileds" : ""}
      title={localization.addPost}
    >
      {postSupplyData.leadStatus <= 4 && (
      <>
        <B2BRevenue
            RevenueData={contractRevenueDetails}
            handleValue={handleRevenueDetails}
        />
      <Commercial
        isSupply
        data={postSupplyData}
        handleValue={handleCommercial}
        supplyNameFun={supplyNameFun}
        splNameData={splNameData}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
      <AgreementContract
        handleValue={handleagreementDtls}
        documentUploadUrl={documentUploadUrl}
        isSupply
        agreementLength={agreementLength}
        showDetails={showAgreementDetails}
      />
      <GSTDetails
        handleValue={handleGstDetails}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
      <ShippedTo
        handleValue={handleShippedTo}
        locationPinCode={shipTolocationPinCode}
        pincodeData={shipToPincodeData}
        leadData={postSupplyData.lead_name}
      />
      <ClientDetails
        handleValue={handleClientData}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        data={postSupplyData}
        clientBillingAddress={clientBillingAddress}
        clientBillingPocData={clientBillingPocData}
      />
        {/*<AddPoc
          handleValue={handlePocData}
        />*/}
      </>
      )}

      {postSupplyData.leadStatus == 9 && (
        <>
          <GateDetails
            handleValue={handleGateDtl}
            data={postSupplyData}
            imageUploadUrl={imageUploadUrl}
            videoUploadUrl={videoUploadUrl}
          />
          {postSupplyData?.commercialData !== undefined && (postSupplyData?.commercialData?.revenue_nature !== 'Valet' && postSupplyData?.commercialData?.revenue_nature !== 'Services') &&
            <MaterialHardware
                handleValue={handleMaterialhardware}
                data={postSupplyData}
                imageUploadUrl={imageUploadUrl}
                videoUploadUrl={videoUploadUrl}
                handleGatesData={handleGatesData}
                handleProductData={handleProductData}
                getMaterial={getMaterial}
                getMateriaById={getMateriaById}
                getBrandById={getBrandById}
                getBrand={getBrand}
            />
          }
          {postSupplyData?.commercialData !== undefined && (postSupplyData?.commercialData?.revenue_nature === 'Valet' || postSupplyData?.commercialData?.revenue_nature === 'Services') &&
              <ContractServices
                  serviceDetails={contractCatService}
                  setVariableServices={setVariableServices}
                  variableServices={variableServices}
                  handleVariableService={handleVariableService}
                  handleFixedService={handleFixedService}
                  handleValue={handleRevenueDetails}
                  setFixedServices={setFixedServices}
                  fixedServices={fixedServices}
                  commercialData={postSupplyData?.commercialData}
              />
          }
          {postSupplyData.commercialData?.commercial_type_id === 5 && (
            <Milestone
              handleValue={handleMileStone}
              totalAmount={postSupplyInputs.commercialData}
              gateData={postSupplyInputs?.gateDetails}
              gateDetailsChanged = {setIsGateDetailsChanged} 
              isGateDetailsChanged = {isGateDetailsChanged} 
            />
          )}
          {(postSupplyData.commercialData?.commercial_type_id === 7 || postSupplyData.commercialData?.commercial_type_id === 6) && (
              <InvoiceModule
                  handleValue={handleInvoiceAmt}
                  data={postSupplyData}
                  prefilledData={postSupplyData?.postsale_data}
                  invoiceAmtData = {postSupplyData?.postsale_data}
              />
          )}
          {postSupplyData?.commercialData !== undefined && postSupplyData?.commercialData?.revenue_nature !== 'Valet' &&
            <Tags
              handleValue={handleTags}
              data={postSupplyData}
            />
          }
          {postSupplyData?.commercialData !== undefined && postSupplyData?.commercialData?.revenue_nature !== 'Valet' &&
            <Installation
              handleValue={handleInstallation}
              leadType={postSupplyData?.lead_type_val}
            />
          }
      
        </>
      )}

    {postSupplyData.leadStatus <= 4 && (
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <button onClick={refreshPage} className="btn btn-primary mb-4">
          {localization.saveAndNext} <img src={Images?.ArrowRight} alt="" />
          </button>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link> */}
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      )}
      {postSupplyData.leadStatus != 4 && (
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      )}
      <ErrModalPop
          title={localization.error}
          show={isErrorModal}
          handleModalHide={handleModalHide1}
          keyboard
          backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
    </Layout>
  );
};


PostSalesSupply.propTypes = {
  history: PropTypes.any,
  postCorporate: PropTypes.func,
};

export default PostSalesSupply;
